export default __webpack_public_path__ + "static/media/mark_run.46392737.png";